import React from 'react';
import { ArcCheckbox, ArcStack, ArcText } from '@src/core/ui';
import { ChecklistItemProps } from './types';

const ChecklistItem: React.FC<ChecklistItemProps> = ({ item, checked, onToggle }) => {
  return (
    <ArcStack
      px={2}
      py={1.2}
      spacing={1}
      borderRadius={1}
      direction='row'
      alignItems='center'
      bgcolor='background.paper'
      justifyContent='space-between'
    >
      <ArcStack flex={1}>
        <ArcText.h6 fontWeight={500}>{item.title}</ArcText.h6>
        <ArcText.caption color='text.secondary'>
          {item.description}
        </ArcText.caption>
      </ArcStack>
      <ArcCheckbox
        size='small'
        color='brand'
        checked={checked}
        onChange={() => onToggle(item.id)}
      />
    </ArcStack>
  );
};

export default ChecklistItem;

